import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { CURSOR_MIN_WIDTH } from './scrubbable.constants.js';
import { cursor, shadow } from './scrubbable.css.js';

const HEIGHT = 10;
const HALF_HEIGHT = HEIGHT / 2;
const STEM_HEIGHT = 3;
const STEM_OFFSET = (HEIGHT - STEM_HEIGHT) / 2;
/**
 * The arrow that gets rendered during a scrub.
 *
 * You may be tempted to try and make this dynamically match the platform's resize cursor, which
 * would mean rendering a white cursor with a black outline on Windows. Do not go down this rabbit
 * hole! Windows cursors look like bitmaps with very carefully placed pixels, and svgs just don't
 * give us enough control to match the appearance. The way we render this cursor with a drop shadow
 * actually helps to make the cursor look more crisp on a 1x screen.
 */
function ScrubCursor({ width }) {
    const d = useMemo(() => {
        const stemWidth = Math.max(width, CURSOR_MIN_WIDTH) - HEIGHT;
        // Draw out the cursor like this (starting from 0):
        //
        //        1      8
        //      / │     │ \
        //     /  │     │  \
        //    /  0└─────┘9  \
        // 2 <                > 7
        //    \  4┌─────┐5  /
        //     \  │     │  /
        //      \ │     │ /
        //       3      6
        //
        // prettier-ignore
        /* eslint-disable prefer-template, @typescript-eslint/restrict-plus-operands -- intentional SVG path string assembled from numeric geometry constants; the `+` layout mirrors the path segments and keeps the inline (0-4)/(4-5)/... annotations readable */
        return (
        // starting at 0
        'M' + HALF_HEIGHT + ' ' + STEM_OFFSET +
            // left arrowhead (0-4)
            'v' + -STEM_OFFSET + 'l' + -HALF_HEIGHT + ' ' + HALF_HEIGHT +
            'l' + HALF_HEIGHT + ' ' + HALF_HEIGHT + 'v' + -STEM_OFFSET +
            // stem bottom (4-5)
            'h' + stemWidth +
            // right arrowhead (5-9)
            'v' + STEM_OFFSET + 'l' + HALF_HEIGHT + ' ' + -HALF_HEIGHT +
            'l' + -HALF_HEIGHT + ' ' + -HALF_HEIGHT + 'v' + STEM_OFFSET +
            // close path and form stem top (9-0)
            'z');
        /* eslint-enable prefer-template, @typescript-eslint/restrict-plus-operands */
    }, [width]);
    return (jsx("svg", { width: width, height: HEIGHT, className: cursor, children: jsx("path", { className: shadow, fill: "#000", stroke: "#fff", d: d }) }));
}
ScrubCursor.displayName = 'Scrubbable.Cursor';

export { ScrubCursor };
//# sourceMappingURL=scrubbable.components.js.map
